import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M21.0241 22H2.9751C2.6991 22 2.4751 21.776 2.4751 21.5C2.4751 18.58 3.7911 15.865 6.0851 14.052C6.3021 13.882 6.6171 13.919 6.7871 14.135C6.9571 14.351 6.9221 14.665 6.7051 14.837C4.7841 16.355 3.6291 18.58 3.4901 21H20.5101C20.3701 18.576 19.2161 16.352 17.2951 14.837C17.0781 14.666 17.0411 14.352 17.2121 14.135C17.3831 13.918 17.6981 13.882 17.9141 14.052C20.2081 15.861 21.5241 18.575 21.5241 21.5C21.5241 21.776 21.3011 22 21.0241 22ZM12.0721 12.994C9.0371 12.994 6.5691 10.526 6.5691 7.493C6.5691 4.464 9.0381 2 12.0721 2C15.1091 2 17.5811 4.464 17.5811 7.493C17.5811 10.526 15.1091 12.994 12.0721 12.994ZM12.0721 3C9.5891 3 7.5691 5.016 7.5691 7.493C7.5691 9.975 9.5891 11.994 12.0721 11.994C14.5581 11.994 16.5811 9.975 16.5811 7.493C16.5811 5.016 14.5591 3 12.0721 3V3Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'MojeO2');

export default Icon;
